/**
 * @name: message
 * @description:
 * @author: qq2575896094
 * @time: 2024/5/23
 */

const prefix = '/onlinecs/order'

/**
 * 查询用户订单列表消息
 * @type {string}
 */
export const queryUserOrderMessage = `${prefix}/queryUserOrderMessagePage`

/**
 * 更新订单纬度状态
 * @type {string}
 */
export const updateOrderMessageStatus = `${prefix}/updateOrderMessageStatus`
